import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({ overline, title, subtitle, light = false, center = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}
    >
      {overline && <p className="text-xs sm:text-sm tracking-[0.25em] uppercase font-bold text-gold mb-4">{overline}</p>}
      <h2 className={`font-display text-4xl sm:text-5xl tracking-tight leading-[1.05] ${light ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
      {subtitle && <p className={`mt-5 text-base leading-relaxed ${light ? "text-white/70" : "text-muted-foreground"}`}>{subtitle}</p>}
    </motion.div>
  );
};
